/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateObserverLinkRequest { 
    description?: string | null;
    accountId?: string | null;
    externalPermissionIds: Array<number>;
    verificationCode: string;
}

